import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpOperatorRoleDefaultsFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpOperatorRoleDefaults
 */

export class ExpOperatorRoleDefaultsFactory {}
_ExpOperatorRoleDefaultsFactory = ExpOperatorRoleDefaultsFactory;
_defineProperty(ExpOperatorRoleDefaultsFactory, "FromJSON", function (json) {
  return _ExpOperatorRoleDefaultsFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpOperatorRoleDefaultsFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'roleID': json['roleID'],
    'outputCategoryID': json['outputCategoryID'],
    'outputValueTypeID': json['outputValueTypeID'],
    'outputMultiple': json['outputMultiple'],
    'sourceOperandName': json['sourceOperandName'],
    'noOperatorInput': json['noOperatorInput'],
    'noFormulaInput': json['noFormulaInput'],
    'defaultOperandCategoryID': json['defaultOperandCategoryID']
  };
});
_defineProperty(ExpOperatorRoleDefaultsFactory, "ToJSON", function (value) {
  return _ExpOperatorRoleDefaultsFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpOperatorRoleDefaultsFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'roleID': value.roleID,
    'outputCategoryID': value.outputCategoryID,
    'outputValueTypeID': value.outputValueTypeID,
    'outputMultiple': value.outputMultiple,
    'sourceOperandName': value.sourceOperandName,
    'noOperatorInput': value.noOperatorInput,
    'noFormulaInput': value.noFormulaInput,
    'defaultOperandCategoryID': value.defaultOperandCategoryID
  };
});
//# sourceMappingURL=ExpOperatorRoleDefaults.js.map
